require('scripts/main');